import { IAgreementListFilterRaw } from 'APIPackage/AgreementListModule/interfaces/IAgreementListFilterRaw';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { SYSTEM_DATE_FORMAT_FNS } from 'CorePackage/MainModule/constants/dateFormats';

import { IAgreementListFilter } from '../interfaces/IAgreementListFilter';

export function mapAgreementFilterToRaw(data: IAgreementListFilter): IAgreementListFilterRaw {
  return {
    name: data.name,
    isKnm: !!data?.types?.find(type => type.id === 'isKnm'),
    isPm: !!data?.types?.find(type => type.id === 'isPm'),
    isDecision: !!data?.types?.find(type => type.id === 'isDecision'),
    statuses: data?.statuses?.map(status => status.id),
    knmTypeIds: data?.knmTypes?.map(knmTypeSelectOption => knmTypeSelectOption?.id) || [],
    isTest: data?.isTest?.value,
    years: data?.years?.map(yearSelectOption => Number(yearSelectOption.value)) || [],
    domainIds: data?.domains?.map(domain => domain?.id) || [],
    includeDomainChild: data?.includeDomainChild,
    executionAgreementDateBetween:
      data?.executionAgreementDateBetweenStart && data?.executionAgreementDateBetweenEnd
        ? [
            formatDate({ date: data.executionAgreementDateBetweenStart, dateFormat: SYSTEM_DATE_FORMAT_FNS }),
            formatDate({ date: data.executionAgreementDateBetweenEnd, dateFormat: SYSTEM_DATE_FORMAT_FNS }),
          ]
        : undefined,
    subjectInn: data?.subjectInn,
    objectOgrn: data?.objectOgrn,
    subjectOrgName: data?.subjectOrgName,
  };
}
